import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ffa154c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "booking-item" }
const _hoisted_2 = {
  key: 0,
  class: "qty-header d-flex justify-space-between"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Akt. Buchung", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Gesamt", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Eingehend", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_item_group = _resolveComponent("v-item-group")!
  const _component_qty_control = _resolveComponent("qty-control")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_ErrorDisplay = _resolveComponent("ErrorDisplay")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_error_display = _resolveComponent("error-display")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_form, {
      ref: "form",
      "lazy-validation": ""
    }, {
      default: _withCtx(() => [
        (!_ctx.derivedReadonly)
          ? (_openBlock(), _createBlock(_component_v_item_group, {
              key: 0,
              style: {"display":"flex"}
            }, {
              default: _withCtx(() => [
                (_ctx.qtyMax > 0)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "rounded-0",
                      elevation: "0",
                      style: {"flex":"auto"},
                      size: "large",
                      color: "primary",
                      disabled: _ctx.qty === _ctx.qtyMax || _ctx.derivedReadonly || _ctx.qtyMax < 0,
                      onClick: _ctx.addAll
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Maximale Menge ")
                      ], undefined, true),
                      _: 1
                    }, 8, ["disabled", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.deletable)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      class: "rounded-0",
                      elevation: "0",
                      size: "large",
                      color: "error",
                      style: _normalizeStyle({ flex: _ctx.qtyMax > 0 ? '' : 'auto' }),
                      disabled: _ctx.derivedReadonly,
                      onClick: _ctx.deletePosition
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-delete")
                          ], undefined, true),
                          _: 1
                        })
                      ], undefined, true),
                      _: 1
                    }, 8, ["style", "disabled", "onClick"]))
                  : _createCommentVNode("", true),
                (!_ctx.deletable && _ctx.qtyMax <= 0)
                  ? (_openBlock(), _createBlock(_component_v_spacer, { key: 2 }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn, {
                  class: "rounded-0",
                  elevation: "0",
                  "selected-class": "primary--text",
                  color: "grey-lighten-3",
                  size: "large",
                  border: "",
                  onClick: _ctx.resetPosition,
                  disabled: _ctx.derivedReadonly
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-restart")
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ], undefined, true),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_card, { flat: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (_ctx.hasSubbookings)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
                  : _createCommentVNode("", true),
                _createVNode(_component_qty_control, {
                  modelValue: _ctx.qty,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.qty) = $event)),
                  max: _ctx.qtyMax,
                  qtyTotal: _ctx.pickedCount,
                  unit: _ctx.position?.Einheit || '',
                  ean: _ctx.position?.Eancode,
                  title: "Menge",
                  label: "Menge",
                  readonly: _ctx.derivedReadonly,
                  "no-zero": !_ctx.picklistPicker.picklist?.isInventory,
                  "allow-overshoot": _ctx.picklistPicker.picklist?.allowOvershoot
                }, null, 8, ["modelValue", "max", "qtyTotal", "unit", "ean", "readonly", "no-zero", "allow-overshoot"]),
                (_ctx.qtyGebinde !== null)
                  ? (_openBlock(), _createBlock(_component_qty_control, {
                      key: 1,
                      modelValue: _ctx.qtyGebinde,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.qtyGebinde) = $event)),
                      spareQtys: _ctx.spareQtysGebinde,
                      max: _ctx.qtyGebindeMax ?? undefined,
                      qtyTotal: _ctx.pickedGebindeCount ?? undefined,
                      unit: _ctx.position?.Gebindeinh ?? '',
                      ean: _ctx.position?.EAN_Gebinde ?? undefined,
                      title: "Gebinde",
                      consistsOf: `${_ctx.position?.Gebinhalt} ${_ctx.position?.Einheit}`,
                      label: "Gebinde",
                      readonly: _ctx.derivedReadonly,
                      "allow-overshoot": _ctx.picklistPicker.picklist?.allowOvershoot
                    }, null, 8, ["modelValue", "spareQtys", "max", "qtyTotal", "unit", "ean", "consistsOf", "readonly", "allow-overshoot"]))
                  : _createCommentVNode("", true),
                (_ctx.qtyPaletten !== null)
                  ? (_openBlock(), _createBlock(_component_qty_control, {
                      key: 2,
                      modelValue: _ctx.qtyPaletten,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.qtyPaletten) = $event)),
                      spareQtys: _ctx.spareQtysPaletten,
                      max: _ctx.qtyPalettenMax ?? undefined,
                      qtyTotal: _ctx.pickedPalettenCount ?? undefined,
                      unit: "Paletten",
                      title: "Paletten",
                      consistsOf: `${_ctx.position?.Umrpalgebinde} ${_ctx.position?.Gebindeinh}`,
                      label: "Paletten",
                      readonly: _ctx.derivedReadonly,
                      "allow-overshoot": _ctx.picklistPicker.picklist?.allowOvershoot
                    }, null, 8, ["modelValue", "spareQtys", "max", "qtyTotal", "consistsOf", "readonly", "allow-overshoot"]))
                  : _createCommentVNode("", true)
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.picklistPicker.picklist?.isUmbuchung)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Abgehend"))
                : _createCommentVNode("", true),
              _createVNode(_component_v_select, {
                modelValue: _ctx.subsidiary,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.subsidiary) = $event)),
                class: "mb-3",
                rules: [_ctx.rules.ruleRequired],
                items: _ctx.subsidiaryOptions,
                hint: _ctx.subsidiaryHintText,
                "persistent-hint": "",
                "item-title": "text",
                "item-value": "value",
                density: "compact",
                required: "true",
                disabled: (_ctx.derivedReadonly && !(_ctx.picklistPicker.picklist?.isUmbuchung &&
             _ctx.picklistPicker.selectedPosition === 0 && _ctx.picklistPicker.picklist.allPositions.length === 1)) ||
             (_ctx.picklistPicker.picklist?.isUmbuchung && _ctx.picklistPicker.picklist.allPositions.length !== 1),
                type: "number",
                label: "Niederlassung",
                "return-object": false
              }, {
                item: _withCtx(({ props, item }) => [
                  _createVNode(_component_v_list_item, _mergeProps(props, {
                    subtitle: item.raw.hint
                  }), null, 16, ["subtitle"])
                ]),
                _: 1
              }, 8, ["modelValue", "rules", "items", "hint", "disabled"]),
              (!_ctx.warehouseLoadError)
                ? (_openBlock(), _createBlock(_component_v_select, {
                    key: 1,
                    modelValue: _ctx.warehouse,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.warehouse) = $event)),
                    class: "mb-3",
                    rules: [_ctx.rules.ruleRequired],
                    items: _ctx.warehouseOptions,
                    "item-title": "text",
                    "item-value": "value",
                    loading: _ctx.warehousesLoading,
                    density: "compact",
                    required: "true",
                    disabled: _ctx.derivedReadonly,
                    type: "number",
                    label: "Lagerhalle",
                    "return-object": false
                  }, null, 8, ["modelValue", "rules", "items", "loading", "disabled"]))
                : (_openBlock(), _createBlock(_component_ErrorDisplay, {
                    key: 2,
                    message: _ctx.warehouseLoadError?.message,
                    loading: _ctx.warehousesLoading,
                    onRetry: _ctx.loadWarehouses
                  }, null, 8, ["message", "loading", "onRetry"])),
              (!_ctx.shelfLoadError)
                ? (_openBlock(), _createBlock(_component_v_combobox, {
                    key: 3,
                    modelValue: _ctx.shelf,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.shelf) = $event)),
                    search: _ctx.shelfSearch,
                    "onUpdate:search": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.shelfSearch) = $event)),
                    class: "mb-3",
                    items: _ctx.shelfOptions,
                    loading: _ctx.shelvesLoading,
                    density: "compact",
                    disabled: _ctx.derivedReadonly,
                    label: "Lagerfach",
                    placeholder: "(keines)",
                    "return-object": false,
                    maxlength: "10",
                    max: _ctx.INT_MAX,
                    "item-title": "value",
                    "item-value": "value"
                  }, {
                    "append-inner": _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_ctx.shelfName), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "search", "items", "loading", "disabled", "max"]))
                : (_openBlock(), _createBlock(_component_error_display, {
                    key: 4,
                    message: _ctx.shelfLoadError?.message,
                    loading: _ctx.warehousesLoading,
                    onRetry: _ctx.loadShelves
                  }, null, 8, ["message", "loading", "onRetry"]))
            ]),
            (_ctx.picklistPicker.picklist?.isUmbuchung)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.destinationSubsidiary,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.destinationSubsidiary) = $event)),
                    class: "mb-3",
                    rules: [_ctx.rules.ruleRequired],
                    items: _ctx.subsidiaryOptions,
                    hint: _ctx.destinationSubsidiaryHintText,
                    "persistent-hint": "",
                    "item-title": "text",
                    "item-value": "value",
                    density: "compact",
                    required: "true",
                    disabled: (_ctx.derivedReadonly && !(_ctx.picklistPicker.picklist?.isUmbuchung &&
             _ctx.picklistPicker.selectedPosition === 0 && _ctx.picklistPicker.picklist.allPositions.length === 1)) ||
             (_ctx.picklistPicker.picklist?.isUmbuchung && _ctx.picklistPicker.picklist.allPositions.length !== 1),
                    type: "number",
                    label: "Niederlassung",
                    "return-object": false
                  }, {
                    item: _withCtx(({ props, item }) => [
                      _createVNode(_component_v_list_item, _mergeProps(props, {
                        subtitle: item.raw.hint
                      }), null, 16, ["subtitle"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "rules", "items", "hint", "disabled"]),
                  (!_ctx.warehouseLoadError)
                    ? (_openBlock(), _createBlock(_component_v_select, {
                        key: 0,
                        modelValue: _ctx.destinationWarehouse,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.destinationWarehouse) = $event)),
                        class: "mb-3",
                        rules: [_ctx.rules.ruleRequired],
                        items: _ctx.destinationWarehouseOptions,
                        "item-title": "text",
                        "item-value": "value",
                        loading: _ctx.warehousesLoading,
                        density: "compact",
                        required: "true",
                        disabled: _ctx.derivedReadonly,
                        type: "number",
                        label: "Lagerhalle",
                        "return-object": false
                      }, null, 8, ["modelValue", "rules", "items", "loading", "disabled"]))
                    : (_openBlock(), _createBlock(_component_ErrorDisplay, {
                        key: 1,
                        message: _ctx.warehouseLoadError?.message,
                        loading: _ctx.warehousesLoading,
                        onRetry: _ctx.loadDestinationWarehouses
                      }, null, 8, ["message", "loading", "onRetry"])),
                  (!_ctx.shelfLoadError)
                    ? (_openBlock(), _createBlock(_component_v_combobox, {
                        key: 2,
                        modelValue: _ctx.destinationShelf,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.destinationShelf) = $event)),
                        search: _ctx.destinationShelfSearch,
                        "onUpdate:search": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.destinationShelfSearch) = $event)),
                        class: "mb-3",
                        items: _ctx.destinationShelfOptions,
                        loading: _ctx.shelvesLoading,
                        density: "compact",
                        disabled: _ctx.derivedReadonly,
                        label: "Lagerfach",
                        placeholder: "(keines)",
                        "return-object": false,
                        maxlength: "10",
                        max: _ctx.INT_MAX,
                        "item-title": "value",
                        "item-value": "value"
                      }, {
                        "append-inner": _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.destinationShelfName), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "search", "items", "loading", "disabled", "max"]))
                    : (_openBlock(), _createBlock(_component_error_display, {
                        key: 3,
                        message: _ctx.shelfLoadError?.message,
                        loading: _ctx.warehousesLoading,
                        onRetry: _ctx.loadDestinationShelves
                      }, null, 8, ["message", "loading", "onRetry"]))
                ]))
              : _createCommentVNode("", true),
            (!_ctx.picklist.isSuggestion)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.picklist.isIncoming ? 'v-combobox' : 'v-autocomplete'), {
                  key: 1,
                  modelValue: _ctx.nve,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.nve) = $event)),
                  search: _ctx.nveSearch,
                  "onUpdate:search": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.nveSearch) = $event)),
                  label: "NVE",
                  required: "true",
                  items: _ctx.filteredNveOptionsLength <= 10 ? _ctx.filteredNveOptions : (_ctx.nve ? [_ctx.nve] : []),
                  "no-data-text": _ctx.filteredNveOptionsLength > 10 ? 'Bitte tippen Sie weiter' : undefined,
                  filled: "",
                  type: "number",
                  disabled: _ctx.derivedReadonly,
                  max: "999999999999999999",
                  rules: [_ctx.rules.ruleMaxLen18],
                  "return-object": false,
                  "item-title": "text",
                  "item-value": "value"
                }, null, 40, ["modelValue", "search", "items", "no-data-text", "disabled", "rules"]))
              : _createCommentVNode("", true),
            ((!_ctx.picklist.isIncoming && !_ctx.picklist.isSuggestion) && _ctx.position?.ChargenpflichtBool)
              ? (_openBlock(), _createBlock(_component_v_combobox, {
                  key: 2,
                  rules: [_ctx.rules.ruleRequired, _ctx.rules.ruleNumber, _ctx.rules.ruleBatchNeedsToExist],
                  modelValue: _ctx.batchNoProxy,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.batchNoProxy) = $event)),
                  label: "Chargennummer",
                  required: "true",
                  disabled: !_ctx.picklist.isUmbuchung && !_ctx.picklist.isCorrection && (_ctx.derivedReadonly || (Boolean(_ctx.nve) && !_ctx.picklist.isIncoming)),
                  clearable: _ctx.picklist.isUmbuchung || _ctx.picklist.isCorrection,
                  variant: "filled",
                  "bg-color": !_ctx.batchNoInAvailable ? 'warning' : undefined,
                  "prepend-inner-icon": !_ctx.batchNoInAvailable ? 'mdi-alert-circle-outline' : undefined,
                  messages: 
            !_ctx.batchNoInAvailable
              ? 'Diese Chargennummer ist für dieses Lager nicht im System verzeichnet'
              : undefined
          ,
                  maxlength: "9",
                  items: _ctx.filteredBatchNoOptions,
                  "return-object": false,
                  onFocusout: _cache[14] || (_cache[14] = ($event: any) => (_ctx.batchNo = _ctx.batchNoProxyValue))
                }, null, 8, ["rules", "modelValue", "disabled", "clearable", "bg-color", "prepend-inner-icon", "messages", "items"]))
              : _createCommentVNode("", true),
            (!_ctx.picklist.isSuggestion && _ctx.position?.SeriennrpflichtBool)
              ? (_openBlock(), _createBlock(_component_v_text_field, {
                  key: 3,
                  rules: [_ctx.rules.ruleRequired],
                  modelValue: _ctx.serialNo,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.serialNo) = $event)),
                  label: "Seriennummer",
                  required: "true",
                  disabled: _ctx.derivedReadonly
                }, null, 8, ["rules", "modelValue", "disabled"]))
              : _createCommentVNode("", true),
            (_ctx.picklist.isIncoming)
              ? (_openBlock(), _createBlock(_component_v_switch, {
                  key: 4,
                  label: "NVE generieren",
                  modelValue: _ctx.generateNve,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.generateNve) = $event))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (_ctx.picklist.isIncoming && _ctx.position?.ChargenpflichtBool)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  _createVNode(_component_v_text_field, {
                    clearable: "",
                    maxlength: "50",
                    label: "Anerkennungsnummer",
                    modelValue: _ctx.acknowledgementNumber,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.acknowledgementNumber) = $event)),
                    "aria-autocomplete": "none",
                    autocomplete: "off"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_text_field, {
                    maxlength: "30",
                    label: "Lieferanten-Chargen-Nr.",
                    modelValue: _ctx.dealerBatchNo,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.dealerBatchNo) = $event)),
                    "aria-autocomplete": "none",
                    autocomplete: "off"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_text_field, {
                    clearable: "",
                    rules: [_ctx.rules.ruleDate],
                    label: "Haltbarkeitsdatum",
                    modelValue: _ctx.bestBeforeDate,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.bestBeforeDate) = $event)),
                    type: "date"
                  }, null, 8, ["rules", "modelValue"]),
                  _createVNode(_component_v_text_field, {
                    clearable: "",
                    rules: [_ctx.rules.ruleDate],
                    label: "Herstellungsdatum",
                    modelValue: _ctx.manufacturingDate,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.manufacturingDate) = $event)),
                    type: "date"
                  }, null, 8, ["rules", "modelValue"])
                ], 64))
              : _createCommentVNode("", true)
          ], undefined, true),
          _: 1
        })
      ], undefined, true),
      _: 1
    }, 512)
  ]))
}